// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"de5864e4","453":"b5a493d9","796":"bdb4e402"}[chunkId] + ".chunk.js";
};